import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import {
  getSideBarfilesActions,
  
  settheStandardIDS,
  setTheNameFormForm,
  settheEmpAssessmentNames ,
  setThePerformsAgentRetrieveseparatestandACtion, ///---to get separate stand
  setThePerformsAgentCreateACtion,
  setThePerformsAgentEditACtion, /////---performances edit
  setPerformanceRetreveAction, ////----performance-----parent----calll
  setTheLastPerformanceIds, ///---lastIDs
  setThePerformsAgentRetrieveACtion,
  setTocalllRetrieve,
  setTheLastObjectwithTotal_points,
  setThePutIdAnswerIds,
  resetQuestionData,
  resetQuestionTypeData,
  resetEmployeeDataquestionslist ,
  gettheSkillassessmentputtmethodEmpactions ,
  gettheSkillassessmentpostmethodEmpactions,
  settheformforskillassessment,
  gettheSkillassessmentRetireveEmpactions
} from "../../../Redux/Slice";
import "../../../StyleSheet/MainComponent/ManPowerPerfomance.scss";
import { useNavigate } from "react-router-dom";
import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import Profile from "../../../Assets/AppComponent/Profile/profile2.png";

const EmpSkillassessmenforms = () => {
  const state = useSelector((state) => state);
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
   const Navigate = useNavigate()
  var indexof;
  const dispatch = useDispatch();
  const [Datas, setDatas] = useState({});
  const [displaydata, setDisplayD] = useState();
  const [CheckedINfo, setCheckedInf] = useState();
  const [name, setName] = useState();
  const [previousecount, setpreviouscount] = useState(false);
  const [innerdata, setinnerdata] = useState();
  const [totalpointsc, settotalpointsc] = useState();
  const [mappedst, setmappedts] = useState();
  var performanceChildDatas =
  state.innerquestionskillassessment.questionData;
  const [total_scorestta, setTotalPointsPut] = useState({ total_score: 0 });
  const [nextCall, setNextCall] = useState(false);
  const [nextmapids, setnexxtmapids] = useState();
  const formatKey = (key) => {
    // Remove underscores and convert to lowercase
    let formattedKey = key.replace(/_/g, " ").toLowerCase();
    // Capitalize first letter of each word
    formattedKey = formattedKey.replace(/\b\w/g, (char) => char.toUpperCase());
    return formattedKey;
  };
 const [callthenextapi , setnextapi] = useState(false)



  useEffect(()=>{
    if (
      state.skillassessmentretieveempdatas.skillassessmentsempDatas != undefined &&
      state.skillassessmentretieveempdatas.skillassessmentsempDatas != null &&
      state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer !=
        undefined &&
      state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer !=
        null
    ) {
      dispatch(
        setThePutIdAnswerIds(
          state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer
            .id
        )
      );
      //perform_answer

    }
  },[state.skillassessmentretieveempdatas.skillassessmentsempDatas ,state.ManPowerActiveDataTabs.ListNames ,callthenextapi]);

  
  // useEffect(() => {
  //   if (state.ManPowerActiveDataTabs.Ids != "") {
  //     state.skillassessmentretieveempdatas.skillassessmentsempDatas != undefined &&
  //       state.skillassessmentretieveempdatas.skillassessmentsempDatas != null &&
  //       state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer !=
  //         undefined &&
  //       state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer !=
  //         null &&
  //       Object.keys(
  //         state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer
  //       ).map((innerKey, index) => {
  //         const value =
  //           state.skillassessmentretieveempdatas.skillassessmentsempDatas
  //             .perform_answer[innerKey];
     
  //         if (
  //           typeof value === "object" &&
  //           value == null &&
  //           state.ManPowerActiveDataTabs.NameForForm != undefined && 

  //           state.ManPowerActiveDataTabs.NameForForm != null &&
  //           state.ManPowerActiveDataTabs.NameForForm.toLowerCase()
  //             .replace(/\s+/g, "_")
  //             .replace(/[^a-z0-9_]/g, "_") === innerKey
  //         ) {
  //           const payload = {
  //             search: "",
  //             page_size: "",
  //             page: 1,
  //             id: state.ManPowerActiveDataTabs.Ids,
  //           };
  //           dispatch(resetQuestionData(payload));
  //         }
  //       });
  //   }

  //   if (state.ManPowerActiveDataTabs.Ids != "") {
  //     if (
  //       state.skillassessmentretieveempdatas.skillassessmentsempDatas != undefined &&
  //       state.skillassessmentretieveempdatas.skillassessmentsempDatas != null &&
  //       state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer ==
  //         null
  //     ) {
  //       const payload = {
  //         search: "",
  //         page_size: "",
  //         page: 1,
  //         id: state.ManPowerActiveDataTabs.Ids,
  //       };
  //       dispatch(resetQuestionData(payload));
  //     }
  //   }
  // }, [
  //   state.ManPowerActiveDataTabs.Ids,
  //   state.ManPowerActiveDataTabs.NameForForm,
  // ]);
  ////--if the performances answer is null




  console.log(state.innerquestionskillassessment ,"innerquestionskillassessment");

  useEffect(() => {
    if (state.ManPowerActiveDataTabs.Ids != undefined &&
      state.ManPowerActiveDataTabs.Ids != "") {
      if (
        state.skillassessmentretieveempdatas.skillassessmentsempDatas != undefined &&
        state.skillassessmentretieveempdatas.skillassessmentsempDatas != null
        //  &&
        // state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer ==
        //   null
      ) {
        const payload = {
          search: "",
          page_size: "",
          page: 1,
          id: state.ManPowerActiveDataTabs.Ids,
        };
        dispatch(resetQuestionData(payload));
      }
    }
  }, [
    state.ManPowerActiveDataTabs.Ids,
    state.ManPowerActiveDataTabs.fortheformSkillAssessment,
    state.ManPowerActiveDataTabs.EditIDs,
    state.ManPowerActiveDataTabs.fortheformSkillAssessment,
    state.ManPowerActiveDataTabs.LastIDSPerformanceidss,
    nextCall,
    state.ManPowerActiveDataTabs.ListNames,
    callthenextapi
  ]);

  useEffect(() => {
    // if (nextCall) {
      if( state.ManPowerActiveDataTabs.SetthefristNameofassessmentemp == ///the  names are equals ,,, then its have to display the total_points
      state.ManPowerActiveDataTabs.LastIDSPerformanceidss ||callthenextapi == true ){
      if (state.ManPowerActiveDataTabs.EditIDs != "") {
        const payload = {
          EditId: state.ManPowerActiveDataTabs.EditIDs,
        };
        dispatch(gettheSkillassessmentRetireveEmpactions(payload));
      }
    }
  }, [
    state.ManPowerActiveDataTabs.EditIDs,
    state.ManPowerActiveDataTabs.NameForForm , 
    state.ManPowerActiveDataTabs.LastIDSPerformanceidss,
    nextCall,
    state.ManPowerActiveDataTabs.SetthefristNameofassessmentemp,

    state.ManPowerActiveDataTabs.ListNames,
    callthenextapi
  ]);

  // useEffect(() => {
  //   // if (nextCall) {
  //     if( state.ManPowerActiveDataTabs.NameForForm == ///the  names are equals ,,, then its have to display the total_points
  //     state.ManPowerActiveDataTabs.LastIDSPerformanceidss ||callthenextapi == true ){
  //     if (state.ManPowerActiveDataTabs.EditIDs != "") {
  //       const payload = {
  //         EditId: state.ManPowerActiveDataTabs.EditIDs,
  //       };
  //       dispatch(setThePerformsAgentRetrieveACtion(payload));
  //     }
  //   }
  // }, [
  //   state.ManPowerActiveDataTabs.EditIDs,
  //   // state.ManPowerActiveDataTabs.NameForForm , 
  //   state.ManPowerActiveDataTabs.fortheformSkillAssessment,
  //   state.ManPowerActiveDataTabs.LastIDSPerformanceidss,
  //   nextCall,
  //   state.ManPowerActiveDataTabs.ListNames,
  //   callthenextapi
  // ]);



  const [datasforchild, setdatasforchild] = useState();

  useEffect(() => {
    if (state.innerquestionskillassessment.questionData != undefined) {
      // Create grooming standard data

      const totalPoints =
        state.performanceChildTypeCall.Total_Count < 10
          ? `0${state.performanceChildTypeCall.Total_Count}`
          : state.performanceChildTypeCall.Total_Count;

      const groomingStandardData =
      state.innerquestionskillassessment.questionData.map(
          (item, index) => ({
            answer: true,
            question:
              item.grading_name !== undefined && item.grading_name !== null
                ? item.grading_name
                : `Question ${index + 1}`,
          })
        );

      // Calculate total points
      const data = {
        data: groomingStandardData,
        total_points: totalPoints,
      };
      setdatasforchild(data);
    }
  }, [state.innerquestionskillassessment.questionData]);


  
  useEffect(() => {
    if (
        state.skillquestionpaperassessment
        .employeeData != undefined
    ) {
      const performsRetrieveseparatData =
      state.skillquestionpaperassessment
      .employeeData;

    }
  }, [
    state.skillquestionpaperassessment
        .employeeData,
  ]);

  useEffect(() => {
    if (
      state.skillassessmentretieveempdatas.skillassessmentsempDatas != undefined &&
      state.skillassessmentretieveempdatas.skillassessmentsempDatas != null &&
      state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer !=
        undefined &&
      state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer !=
        null
    ) {
      var mappedOne = [];
      Object.keys(
        state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer
      ).map((innerKey, index) => {
        const value =
          state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer[
            innerKey
          ];
           
          console.log(state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer ,"perform_answer" );
          
        if (value != null && value != undefined && typeof value === "object") {
          Object.entries(value).map(([subkey, subvalue], index) => {
            //  console.log(subkey, "subkeyiusdg"  , subvalue , index , innerKey);
            if (subkey == "total_points") {
              console.log("subvalue", subvalue);
              //   console.log({[innerKey ] : subvalue}, "hfgsdyfgsd");
              mappedOne.push({ [innerKey]: subvalue });

              setmappedts(mappedOne);
              // console.log(mappedOne, "mappedOne");
            }
          });
        }
      });
      // console.log(mappedst, "mappedst");
      dispatch(setTheLastObjectwithTotal_points(mappedOne)); ////----the---header--name---and---total_points
    }
  }, [state.skillassessmentretieveempdatas.skillassessmentsempDatas, nextCall


  ]);

  ////---parent------call-----
  useEffect(() => {
    if (state.ManPowerActiveDataTabs.Ids != undefined) {
      const payload = {
        id: state.ManPowerActiveDataTabs.Ids,
      };
    //   dispatch(setPerformanceRetreveAction(payload));
    dispatch(resetQuestionTypeData(payload))
    }
  }, [state.ManPowerActiveDataTabs.Ids, state.ManPowerActiveDataTabs.fortheformSkillAssessment]);


  ///---dispatch separate performance stand---

  /////------retrieve- the send datas
  useEffect(() => {
    if (state.ManPowerActiveDataTabs.Ids != "") {
      state.skillassessmentretieveempdatas.skillassessmentsempDatas != undefined &&
        state.skillassessmentretieveempdatas.skillassessmentsempDatas != null &&
        state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer !=
          undefined &&
        state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer !=
          null &&
        Object.keys(
          state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer
        ).map((innerKey, index) => {
          const value =
            state.skillassessmentretieveempdatas.skillassessmentsempDatas
              .perform_answer[innerKey];
          
          if (
            
            typeof value === "object" &&
            value != null &&
            state.ManPowerActiveDataTabs.SetthefristNameofassessmentemp != undefined &&
            state.ManPowerActiveDataTabs.SetthefristNameofassessmentemp != null &&
            state.ManPowerActiveDataTabs.SetthefristNameofassessmentemp.toLowerCase()
              .replace(/\s+/g, "_")
              .replace(/[^a-z0-9_]/g, "_") === innerKey
          ) {
            const date = new Date();
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const payload = {
              question_id: state.ManPowerActiveDataTabs.Ids,
              userid: state.ManPowerActiveDataTabs.EditIDs, ///----useoooid
              year: year,
              month: month,
            };

            dispatch(resetEmployeeDataquestionslist(payload));
          }
        });
    }

    //   }
  }, [state.ManPowerActiveDataTabs.Ids]);

  useEffect(() => {
    if (
      state.skillassessmentretieveempdatas.skillassessmentsempDatas != undefined &&
      state.skillassessmentretieveempdatas.skillassessmentsempDatas != null &&
      state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer !=
        undefined &&
      state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer !=
        null &&
      state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types !=
        undefined &&
      state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types !=
        null &&
      state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types
        .perform_id != undefined &&
      state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types
        .perform_id != null &&
      state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types
        .perform_id &&
      state.skillassessmentretieveempdatas.skillassessmentsempDatas != undefined &&
      state.skillassessmentretieveempdatas.skillassessmentsempDatas != null &&
      state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer !=
        undefined &&
      state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer !=
        null
    ) {
      Object.keys(
        state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer
      ).map((innerKey, index) => {

        state.skillassessmentretieveempdatas.skillassessmentsempDatas != undefined &&
          state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types !=
            undefined &&
          state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types !=
            null &&
          state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types
            .perform_id != undefined &&
          state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types
            .perform_id != null &&
          state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_types.perform_id.map(
            (item, index) => {
              if (
                innerKey ==
                item.grading_name
                  .toLowerCase()
                  .replace(/\s+/g, "_")
                  .replace(/[^a-z0-9_]/g, "_")
              )
                console.log(
                  innerKey ==
                    item.grading_name
                      .toLowerCase()
                      .replace(/\s+/g, "_")
                      .replace(/[^a-z0-9_]/g, "_"),
                  "transformedGradingName",
                  innerKey,
                  item.grading_name
                    .toLowerCase()
                    .replace(/\s+/g, "_")
                    .replace(/[^a-z0-9_]/g, "_")
                );

              if (
                innerKey != undefined &&
                innerKey ==
                  item.grading_name
                    .toLowerCase()
                    .replace(/\s+/g, "_")
                    .replace(/[^a-z0-9_]/g, "_") &&
                typeof innerKey === "object"
              ) {
                dispatch(setTocalllRetrieve(true));
              } else {
                dispatch(setTocalllRetrieve(false));
              }
            }
          );
      });
    }
  }, [state.ManPowerActiveDataTabs.Ids]);

  const [test, settest] = useState([]);

  // useEffect(() => {
  //   if (

  //     state.ManPowerActiveDataTabs.NameForForm != undefined &&
  //     state.ManPowerActiveDataTabs.NameForForm != null &&
  //     state.skillquestionpaperassessment
  //       .employeeData != null &&
  //       state.skillquestionpaperassessment
  //       .employeeData != undefined
  //   ) {
  //     ///--when the----get name is same then only it have to set the  current one
  //     if (
  //       state.ManPowerActiveDataTabs.Ids != "" &&
  //       state.skillquestionpaperassessment
  //       .employeeData != undefined &&
  //       state.skillquestionpaperassessment
  //       .employeeData != null
  //     ) {
  //       state.skillquestionpaperassessment
  //       .employeeData != undefined &&
  //       state.skillquestionpaperassessment
  //       .employeeData.data != undefined &&
  //       state.skillquestionpaperassessment
  //       .employeeData.data != null &&
  //         state.skillassessmentretieveempdatas.skillassessmentsempDatas != undefined &&
  //         state.skillassessmentretieveempdatas.skillassessmentsempDatas != null &&
  //         state.skillassessmentretieveempdatas.skillassessmentsempDatas
  //           .perform_answer != undefined &&
  //         state.skillassessmentretieveempdatas.skillassessmentsempDatas
  //           .perform_answer != null &&
  //         Object.keys(
  //           state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer
  //         ).map((innerKey, index) => {
  //           const value =
  //             state.skillassessmentretieveempdatas.skillassessmentsempDatas
  //               .perform_answer[innerKey];
  //           console.log(typeof value, "8wej=eh", value);
  //           console.log(
  //             innerKey ==
  //               state.ManPowerActiveDataTabs.NameForForm.toLowerCase()
  //                 .replace(/\s+/g, "_")
  //                 .replace(/[^a-z0-9_]/g, "_") && value != null,
  //             "pdsmsdaiosd"
  //           );

  //           if (
  //             typeof value === "object" &&
  //             value != null &&
  //             state.ManPowerActiveDataTabs.NameForForm.toLowerCase()
  //               .replace(/\s+/g, "_")
  //               .replace(/[^a-z0-9_]/g, "_") === innerKey
  //           ) {
  //             /////------retrieve-----imeplement-----------------------------------------------
   
  //             // ///---updated response changes one
  //             setinnerdata((prevInnerData) => {
  //               const updatedInnerData = { ...prevInnerData };
  //               const groomingStandardKey =
  //                 state.ManPowerActiveDataTabs.NameForForm;
  //               const HeaderName =
  //                 state.ManPowerActiveDataTabs.NameForForm.toLowerCase()
  //                   .replace(/\s+/g, "_")
  //                   .replace(/[^a-z0-9_]/g, "_");
  //               const data =
  //               state.skillquestionpaperassessment
  //               .employeeData.data;
  //               const innerdataslist =
  //               state.skillquestionpaperassessment
  //               .employeeData.data;

              
  //               return {
  //                 ...updatedInnerData,
  //                 [HeaderName]: {
  //                   // ...data,
  //                   data: state.skillquestionpaperassessment
  //                   .employeeData.data,
  //                   ["total_points"]:
  //                   state.questiontypeskillassessment.questionTypeData.total_points,

  //                 },
  //                 ["user_id"]: state.ManPowerActiveDataTabs.EditIDs,
  //               };
  //             });
  //           }
  //         });
  //     }
  //   }
  // }, [
  //   state.skillquestionpaperassessment
  //       .employeeData,
  //   state.ManPowerActiveDataTabs.Ids,
  // ]);

  ///----Next---last---objects----------
 
 
 
 
  var total_score = 0;

  /////-----Total----points-----------------------------
  useEffect(() => {
    if (
      // state.ManPowerActiveDataTabs.tocallretrieve &&
      state.skillassessmentretieveempdatas.skillassessmentsempDatas != undefined &&
      state.skillassessmentretieveempdatas.skillassessmentsempDatas != null &&
      state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer !=
        undefined &&
      state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer !=
        null
    ) {
      
      var score = [];
      var mappedOne = [];
      var to;
      Object.keys(
        state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer
      ).map((innerKey, index) => {

        const value =
          state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer[
            innerKey
          ];

        if (value != null && value != undefined && typeof value === "object") {
          Object.entries(value).map(([subkey, subvalue], index) => {
            //  console.log(subkey, "subkeyiusdg"  , subvalue , index , innerKey);
            if (subkey == "total_points") {
              console.log("subvalue", subvalue);
              //   console.log({[innerKey ] : subvalue}, "hfgsdyfgsd");
              mappedOne.push({ [innerKey]: subvalue });
              setmappedts(mappedOne);
              console.log("mappedOne", subvalue + subvalue);
              total_score += subvalue;
              score.push(subvalue);
            }
          });
        }
      });

      let values = 0;
      for (let index = 0; index < score.length; index++) {
        const element = score[index];
        values += Number(element);
      }

      const totalScoreString = values.toString();
      const truncatedTotalScore =
        totalScoreString.length <= 15
          ? totalScoreString
          : totalScoreString.slice(0, 15);

      setTotalPointsPut({
        ...total_scorestta,
        total_score: truncatedTotalScore,
      });


      dispatch(setTheLastObjectwithTotal_points(mappedOne)); ////----the---header--name---and---total_points
      
    }
  }, [state.skillassessmentretieveempdatas.skillassessmentsempDatas]);

  var modifiedLabel;
  useEffect(() => {
    if (state.innerquestionskillassessment.questionData != "") {
      const Keysent = [];
      state.innerquestionskillassessment.questionData.map(
        (item, index) => {
          Keysent.push({ label: item.grading_name });

          modifiedLabel = item.grading_name
            .toLowerCase()
            .replace(/\s+/g, "_")
            .replace(/[^a-z0-9_]/g, "_");

        }
      );
      setDisplayD(Keysent);
    }
  }, [
    state.innerquestionskillassessment.questionData,
    state.ManPowerActiveDataTabs.Ids,
  ]);

  useEffect(() => {
    if (
        state.skillquestionpaperassessment
        .employeeData == null &&
        state.ManPowerActiveDataTabs.SetthefristNameofassessmentemp != undefined
    ) {
      setName(state.ManPowerActiveDataTabs.SetthefristNameofassessmentemp);
      const modifiedNameForForm = {
        ...state.ManPowerActiveDataTabs.SetthefristNameofassessmentemp,
      };
    }
    // );

    var modifiedLabel = [];

    if (
      state.questiontypeskillassessment.questionTypeData != undefined &&
      // state.ManPowerActiveDataTabs.NameForForm != undefined &&
      // state.ManPowerActiveDataTabs.NameForForm != null &&
      state.ManPowerActiveDataTabs.Ids == state.ManPowerActiveDataTabs.Ids
    ) {
      state.ManPowerActiveDataTabs.SetthefristNameofassessmentemp != undefined &&
        state.skillassessmentretieveempdatas.skillassessmentsempDatas != undefined &&
        state.skillassessmentretieveempdatas.skillassessmentsempDatas != null &&
        state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer !=
          undefined &&
        state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer !=
          null &&
        Object.keys(
          state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer
        ).map((innerKey, index) => {
          const value =
            state.skillassessmentretieveempdatas.skillassessmentsempDatas
              .perform_answer[innerKey];


          if (
            typeof value === "object" &&
            value == null &&
            state.ManPowerActiveDataTabs.SetthefristNameofassessmentemp.toLowerCase()
              .replace(/\s+/g, "_")
              .replace(/[^a-z0-9_]/g, "_") === innerKey
          ) {
            state.innerquestionskillassessment.questionData.forEach(
              (item) => {
                const key = item.grading_name;

                modifiedLabel.push(key != undefined ? key : "");

                // Push total_points to modifiedLabel
                modifiedLabel.push("total_points");
              }
            );
          }
        });

      // ///--when the----get name is same then only it have to set the  current one
      // state.skillassessmentretieveempdatas.skillassessmentsempDatas != undefined &&
      //   state.skillassessmentretieveempdatas.skillassessmentsempDatas != null &&
      //   state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer !=
      //     undefined &&
      //   state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer !=
      //     null &&
      //   Object.keys(
      //     state.skillassessmentretieveempdatas.skillassessmentsempDatas.perform_answer
      //   ).map((innerKey, index) => {
      //     const value =
      //       state.skillassessmentretieveempdatas.skillassessmentsempDatas
      //         .perform_answer[innerKey];

      //     if (
      //       typeof value === "object" &&
      //       value == null &&
      //       state.ManPowerActiveDataTabs.NameForForm.toLowerCase()
      //         .replace(/\s+/g, "_")
      //         .replace(/[^a-z0-9_]/g, "_") === innerKey
      //     ) {
      //       setinnerdata((prevInnerData) => {
      //         const updatedInnerData = { ...prevInnerData };
      //         const groomingStandardKey =
      //           state.ManPowerActiveDataTabs.NameForForm.toLowerCase()
      //             .replace(/\s+/g, "_")
      //             .replace(/[^a-z0-9_]/g, "_");
      //         const performanceChildData =
      //         state.innerquestionskillassessment.questionData;
      //         const totalPoints = state.questiontypeskillassessment.questionTypeData.total_points


      //         const groomingStandardData = performanceChildData.map(
      //           (item, index) => ({
      //             answer: true,
      //             question:
      //               item.grading_name !== undefined &&
      //               item.grading_name !== null
      //                 ? item.grading_name
      //                 : `Question ${index + 1}`,
      //           })
      //         );

      //         // Calculate total points
      //         const data = {
      //           data: groomingStandardData,
      //           total_points: totalPoints,
      //         };
      //         return {
      //           ...updatedInnerData,
      //           [groomingStandardKey]: data,
      //           user_id: state.ManPowerActiveDataTabs.EditIDs,
      //         };
      //       });
      //     }
      //   });

      if (
        state.ManPowerActiveDataTabs.Ids != undefined && 
        state.ManPowerActiveDataTabs.Ids != "" &&
        state.ManPowerActiveDataTabs.Ids == state.ManPowerActiveDataTabs.Ids
      ) {
        if (
          state.skillassessmentretieveempdatas.skillassessmentsempDatas != undefined &&
          state.skillassessmentretieveempdatas.skillassessmentsempDatas != null
          //  &&
          // state.skillassessmentretieveempdatas.skillassessmentsempDatas
          //   .perform_answer == null
        ) {


          
          // setinnerdata((prevInnerData) => {
          //   const updatedInnerData = { ...prevInnerData };
          //   const groomingStandardKey =
          //     state.ManPowerActiveDataTabs.NameForForm.toLowerCase()
          //       .replace(/\s+/g, "_")
          //       .replace(/[^a-z0-9_]/g, "_");
          //   const performanceChildData =
          //   state.questiontypeskillassessment.questionTypeData;
          //   const totalPoints = state.innerquestionskillassessment.questionData.total_points


          //   // Create grooming standard data
          //   const groomingStandardData = performanceChildData.map(
          //     (item, index) => ({
          //       answer: true,
          //       question:
          //         item.grading_name !== undefined && item.grading_name !== null
          //           ? item.grading_name
          //           : `Question ${index + 1}`,
          //     })
          //   );

          //   const data = {
          //     data: groomingStandardData,
          //     total_points: totalPoints,
          //   };
          //   return {
          //     ...updatedInnerData,
          //     [groomingStandardKey]: data,
          //     user_id: state.ManPowerActiveDataTabs.EditIDs,
          //   };
          // });

          setinnerdata((prevInnerData) => {
            const updatedInnerData = { ...prevInnerData };
          
            // Array of names to be used as keys in innerData
            const formNames = state.ManPowerActiveDataTabs.fortheformSkillAssessment; // Assuming it's an array of form names
          
            // Iterate over each form name and generate the key and corresponding data
            formNames.forEach((name, index) => {
              const groomingStandardKey = name.grading_name
                .toLowerCase()
                .replace(/\s+/g, "_")
                .replace(/[^a-z0-9_]/g, "_");
          
              // Access question data and total points for each form
              const performanceChildData = state.questiontypeskillassessment.questionTypeData;
              // const totalPoints = performanceChildData.total_points;
                        const totalPoints = state.ManPowerActiveDataTabs.fortheformSkillAssessment[index].total_points;

              // Map over performanceChildData to create groomingStandardData
              const groomingStandardData = performanceChildData.map((item, index) => ({
                answer: true,
                question: item.grading_name ?? `Question ${index + 1}`, // Use grading_name or a default question label
              }));

          
              // Create data structure for each form
              const data = {
                data: groomingStandardData,
                total_points: totalPoints,
              };
          console.log(data ,"asiua sdata");
          
              // Add the generated key-value pair to updatedInnerData
              updatedInnerData[groomingStandardKey] = data;
            });
          
            // Return the updated innerData object with user_id
            return {
              ...updatedInnerData,
              user_id: state.ManPowerActiveDataTabs.EditIDs,
            };
          });
          
       
        }
      }
    }
  }, [
    // state.ManPowerActiveDataTabs.NameForForm,
    state.ManPowerActiveDataTabs.fortheformSkillAssessment,
    state.ManPowerActiveDataTabs.ListNames,
    state.innerquestionskillassessment.questionData,
    state.ManPowerActiveDataTabs.Ids,
    state.questiontypeskillassessment.questionTypeData
  ]);

console.log(state.ManPowerActiveDataTabs.total_ids ,"state.ManPowerActiveDataTabs.total_ids",

  
);

  const handleYesChange = (subKey, newValue, index) => {


    setinnerdata((prevInnerdata) => {
      const updatedInnerdata = { ...prevInnerdata };

      console.log(updatedInnerdata, "updatedInnasdasderdata");
      // Iterate over the keys of updatedInnerdata
      Object.keys(updatedInnerdata).forEach((key) => {
        // console.log(updatedInnerdata[key].total_points , "" , updatedInnerdata[key]);

        // Check if the key corresponds to grooming standard data
        if (
          updatedInnerdata[key] &&
          Array.isArray(updatedInnerdata[key].data)
        ) {
          // Update 'data' array in grooming standard
          console.log(updatedInnerdata[key], "updatedInnerdata[key] ");
          updatedInnerdata[key] = {
            ...updatedInnerdata[key],
            data: updatedInnerdata[key].data.map((item) => {
              // Check if the question matches subKey, then return a new object with updated answer
              if (item.question === subKey) {
                return { ...item, answer: newValue };
              }
              return item; // Return the original item for other questions
            }),
          };
        }

        console.log(updatedInnerdata, "updatedInnerdata");
        // Update 'total_points' value if it exists and is a valid number
        if (!isNaN(updatedInnerdata[key].total_points)) {
          // updatedInnerdata[key].total_points = (
          //   parseFloat(
          //     updatedInnerdata[key].total_points) + 
          //   (newValue ? (Number(state.ManPowerActiveDataTabs.fortheformSkillAssessment[0].points)) 
          //    : - Number(state.ManPowerActiveDataTabs.fortheformSkillAssessment[0].points))
          // ).toFixed(4);

          updatedInnerdata[key].total_points = (
            parseFloat(
                  updatedInnerdata[key].total_points) + 
                (newValue ? (Number(state.ManPowerActiveDataTabs.fortheformSkillAssessment[0].points)) 
                 : - Number(state.ManPowerActiveDataTabs.fortheformSkillAssessment[0].points))
              );
          
        }
      });

      return updatedInnerdata;
    });
  };

 


console.log(innerdata ,"sadius dioasdu asdoisud asd");

  const HandleNext = () => {
     
    //-----------The----last--------Page--------------------
    if (
      state.ManPowerActiveDataTabs.SetthefristNameofassessmentemp !=
      state.ManPowerActiveDataTabs.LastIDSPerformanceidss
    ) {
      ////---setThePerformsAgentEditACtion----edit-----------------
      ////----------------setThePerformsAgentCreateACtion---------------

      if (
        // state.PerformsFieldAgentCreate.performsCreateData != null
        state.skillquestionpaperassessment
        .employeeData != undefined ||
        state.PerformsFieldAgentCreate.performsCreateData != undefined
      ) {

        state.ManPowerActiveDataTabs.Ids != "" &&
          state.ManPowerActiveDataTabs.total_ids.forEach((element, index) => {
            
            if (state.ManPowerActiveDataTabs.Ids == element) {

              dispatch(
                settheStandardIDS(
                  state.ManPowerActiveDataTabs.total_ids[index + 1]
                )
              );
              dispatch(
                setTheNameFormForm(
                  state.ManPowerActiveDataTabs.ListNames[index + 1]
                )
              );
              dispatch(settheEmpAssessmentNames(state.ManPowerActiveDataTabs.ListNames[index + 1]))
            
              dispatch(settheformforskillassessment([state.ManPowerActiveDataTabs.ListofSkillAssessment[index + 1]]))

              setinnerdata("");

              if (
                state.ManPowerActiveDataTabs.SetthefristNameofassessmentemp == ///the  names are equals ,,, then its have to display the total_points
                state.ManPowerActiveDataTabs.LastIDSPerformanceidss
              ) {
                setNextCall(true);
              }


              if (
        index == 0
        
              ) {
                const date = new Date();
                const year = date.getFullYear();
                const month = date.getMonth() + 1;
                setnextapi(true);
                const payload = {
                  innerdata: innerdata,
                  question_id: state.ManPowerActiveDataTabs.Ids,
                  userid: state.ManPowerActiveDataTabs.EditIDs, ///----useoooid
                  year: year,
                  month: month,
                };
                dispatch(gettheSkillassessmentpostmethodEmpactions(payload)); ///--create---
              } else if (


                index != 0

              ) {
                const date = new Date();
                const year = date.getFullYear();
                const month = date.getMonth() + 1;

                const payload = {
                  innerdata: innerdata,
                  question_id: state.ManPowerActiveDataTabs.Ids,
                  userid: state.ManPowerActiveDataTabs.EditIDs, ///----useoooid
                  year: year,
                  month: month,

                  EditId: state.ManPowerActiveDataTabs.putIDS,
                  count: 1,
                };

                console.log(payload,"odiasudpoiasdpayload",index ,index != 0);
                setnextapi(true);
                dispatch(gettheSkillassessmentputtmethodEmpactions(payload)); ////----edit

                if (
                  state.ManPowerActiveDataTabs.SetthefristNameofassessmentemp == ///the  names are equals ,,, then its have to display the total_points
                  state.ManPowerActiveDataTabs.LastIDSPerformanceidss
                ) {
                  setNextCall(true);
                }
              }
            }
            setpreviouscount(true);
          });
      }
    }
    
    
    
    if (
      state.ManPowerActiveDataTabs.SetthefristNameofassessmentemp == ///the  names are equals ,,, then its have to display the total_points
      state.ManPowerActiveDataTabs.LastIDSPerformanceidss
    ) {
      setNextCall(true);
      setnextapi(true);
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;

      const payload = {
        innerdata: innerdata,
        question_id: state.ManPowerActiveDataTabs.Ids,
        userid: state.ManPowerActiveDataTabs.EditIDs, ///----useoooid
        year: year,
        month: month,

        EditId: state.ManPowerActiveDataTabs.putIDS,
        count: 1,
      };

    
      dispatch(gettheSkillassessmentputtmethodEmpactions(payload)); ////----edit

    }
  };

  
  
  const addedValue = (val) => {
    console.log(Number(val) + Number(val), "vaashdasdasul");
    return val + val;
  };



  ////--previous-------display---------

  const handelPrevious = () => {

    state.ManPowerActiveDataTabs.total_ids.forEach((element, index) => {
      if (state.ManPowerActiveDataTabs.Ids == element) {

        setinnerdata("");
        if (index === 0) {

          dispatch(
            setTheNameFormForm(

              state.ManPowerActiveDataTabs.ListNames[state.ManPowerActiveDataTabs.ListNames.length - 1]
            )
          ); 
          
          dispatch(settheEmpAssessmentNames(state.ManPowerActiveDataTabs.ListNames[state.ManPowerActiveDataTabs.ListNames.length - 1]))

          ///---here---dispatch---Name
          dispatch(settheStandardIDS(state.ManPowerActiveDataTabs.total_ids[state.ManPowerActiveDataTabs.total_ids.length - 1]));
          dispatch(settheformforskillassessment([state.ManPowerActiveDataTabs.ListofSkillAssessment[state.ManPowerActiveDataTabs.total_ids.length - 1]]))


        }


        else { 
        dispatch(
          settheStandardIDS(state.ManPowerActiveDataTabs.total_ids[index - 1])
        );
        dispatch(
          setTheNameFormForm(state.ManPowerActiveDataTabs.ListNames[index - 1])
        ); ///---here---dispatch---Name
        dispatch(settheformforskillassessment([state.ManPowerActiveDataTabs.ListofSkillAssessment[index - 1]]))
        dispatch(settheEmpAssessmentNames(state.ManPowerActiveDataTabs.ListNames[index - 1]))

        }
        setpreviouscount(true);
      }


    });
  };


  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

   console.log(innerdata ,"saiudasid innerdata");
   console.log(state.questiontypeskillassessment.questionTypeData ,"questiontypeskillassessment" ,
    state.skillquestionpaperassessment
    .employeeData.data ,
  
    state.innerquestionskillassessment.questionData ,
    state.skillassessmentretieveempdatas.skillassessmentsempDatas ,
  );
  console.log(state.skillassessmentretieveempdatas.skillassessmentsempDatas, "iaus skillassessmentsempDatas", 
    
  );
console.log(
  // state.ManPowerActiveDataTabs.fortheformSkillAssessment ,"fortheformSkillAssessment",
  // state.ManPowerActiveDataTabs.ListofSkillAssessment , 
  innerdata,"fortheformSkillAssessment ysdasdkj asdoasd ",
  state.ManPowerActiveDataTabs.fortheformSkillAssessment ,
  state.ManPowerActiveDataTabs.NameForForm , 
  
  state.ManPowerActiveDataTabs.ListNames,
  
  state.ManPowerActiveDataTabs.SetthefristNameofassessmentemp , 
  state.ManPowerActiveDataTabs.LastIDSPerformanceidss,
  state.ManPowerActiveDataTabs.LastObjectWithName_total

  // state.ManPowerActiveDataTabs.SetthefristNameofassessmentemp

  // state.questiontypeskillassessment.questionTypeData, 
  // state.innerquestionskillassessment.questionData , 
  // state.ManPowerActiveDataTabs.Ids
 );
  
  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div style={{padding:"20px 0px"}}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>SKILL ASSESSMENT FORM </h3>


          </div>
        </div>



        <div
          className="row Filters ButtonPrevious"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",
               
            marginLeft: "0px",
            marginRight: "0px",
            top: "-30px",
          }}
        >
          <div className="col">
            <button
              className="btn BackImga"
              onClick={(e) => {
                Navigate("/assessments_apply");
              }}
            >
                  <img  className="PreviousPages" src={BackImage}/>
                  <span></span>

            </button>
          </div>
        </div>




        {/* <div className="Header-Details" style={{ marginTop: "20px" }}>
          <div className="InnerDetails">
            <div className="InnerDetailPart">
              <div className="LOGO">
                <img src={profile2} />
              </div>
              {state.skillassessmentretieveempdatas.skillassessmentsempDatas !=
                undefined &&
              state.skillassessmentretieveempdatas.skillassessmentsempDatas != null &&
              state.skillassessmentretieveempdatas.skillassessmentsempDatas.user_id !=
                undefined &&
              state.skillassessmentretieveempdatas.skillassessmentsempDatas.user_id !=
                null &&
              state.skillassessmentretieveempdatas.skillassessmentsempDatas.user_id.first_name.toUpperCase() ? (
                <p>
                  {state.skillassessmentretieveempdatas.skillassessmentsempDatas.user_id.first_name.toUpperCase()}
                </p>
              ) : (
                <p>{"---"}</p>
              )}
            </div>
            <div className="ROLE">
              <div className="LOGO">
                {state.skillassessmentretieveempdatas.skillassessmentsempDatas !=
                  undefined &&
                state.skillassessmentretieveempdatas.skillassessmentsempDatas.user_id !=
                  undefined &&
                state.skillassessmentretieveempdatas.skillassessmentsempDatas.user_id !=
                  null &&
                state.skillassessmentretieveempdatas.skillassessmentsempDatas.user_id
                  .user_role.role ? (
                  <h4>
                    {
                      state.skillassessmentretieveempdatas.skillassessmentsempDatas
                        .user_id.user_role.role
                    }
                  </h4>
                ) : (
                  <h4>{"---"}</h4>
                )}
              </div>
            </div>
          </div>
        </div> */}

        {!nextCall &&
          innerdata != undefined &&
          innerdata != null &&
          Object.keys(innerdata).map((innerKey, index) => {
            const value = innerdata[innerKey];


            return (
              <div
                className="col-11  ManPowerPerformancesMark "
                key={index}
                 style={{padding:"0px 30px"}}
               
              >
                <div className="col-12">
                  <div style={{ padding: "10px 0px" }}>
                    {innerKey != "user_id" && innerKey !== "total_points" ? (
                      <h2 style={{ fontWeight: "600" }}>
                        {formatKey(innerKey)}
                      </h2>
                    ) : null}
                  </div>
                </div>
                {typeof value === "object" ? (

                  <ul>
                    {Object.entries(value).map(([subKey, subValue], index) => {

                      return (
                        <>
                          <div className="row fortotalscores ">
                            <div className="col-12 mt-3">
                              {subKey !== "total_points" ? (
                                <>
                                  {subValue != null &&
                                    subValue != undefined &&
                                    subValue.map((item, index) => {
                                      console.log(index, item, "sjdsidwijd");

                                      return (
                                        // <h5 key={subKey}>{formatKey(subKey)}</h5> ///previous response data

                                        <div
                                          className="row"
                                          style={{ marginBottom: "16px" , marginLeft:"0ppx", marginRight:"0px" }}
                                        >
                                          <div className="col-6">
                                            <h4
                                              key={index}
                                              style={{
                                                fontWeight: "800",
                                                // marginBottom: "44px",
                                              }}
                                            >
                                              {item.question}
                                            </h4>
                                          </div>
                                          <div className="col-4">
                                            <div
                                              style={{
                                                display: "flex",
                                                gap: "12px",
                                                //marginBottom: "55px",
                                              }}
                                            >
                                              <input
                                                type="radio"
                                                style={{
                                                  width: "30px",
                                                  borderRadius: "12px",
                                                  cursor: "pointer",
                                                }}
                                                //checked={subValue}
                                                checked={item.answer}
                                                //onChange={(subKey ,subValue ,index)=>{
                                                //  handleYesChange(subKey ,subValue ,index)

                                                // }}
                                                onChange={() => {
                                                  handleYesChange(
                                                    // subKey,
                                                    item.question,
                                                    true,
                                                    index
                                                  );
                                                }}
                                              ></input>
                                              <label>{"yes"}</label>

                                              <input
                                                type="radio"
                                                style={{
                                                  width: "30px",
                                                  borderRadius: "12px",
                                                  cursor: "pointer",
                                                }}
                                                //checked={!subValue}
                                                checked={!item.answer}
                                                onChange={() => {
                                                  handleYesChange(
                                                    // subKey,
                                                    item.question,
                                                    false,
                                                    index
                                                  );
                                                }}
                                              ></input>
                                              <label>{"No"}</label>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                </>
                              ) : null}
                            </div>
                            {subKey === "total_points" ? (
                              //  &&
                              ///  innerKey !== "user_id"
                              // <h5>Total Points: {value}</h5>
                              <div
                                className="row RoleButton totalscore"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  width: "100%",
                                  marginLeft:"0ppx", marginRight:"0px",
                                  marginLeft:"-51px"
                                }}
                              >
                                <div
                                  className="col-6 mt-3"
                                  style={{ paddingLeft: "29px" }}
                                >
                                  <h2
                                    style={{ color: "#234492", width: "500px" }}
                                  >
                                    Total Score
                                  </h2>
                                </div>
                                <div
                                  className="col-6 mt-3"
                                  style={{ paddingLeft: "59px" }}
                                >
                                  <button 
                                    class="btn SaveBtn ButtonCSS"
                                    style={{ padding: "6px 5px" }}
                                  >
                                    {value.total_points}
                                  </button>
                                </div>
                              </div>
                            ) : 
                            null}
                          </div>
                        </>
                      );
                    })}
                  </ul>
                ) : (
                  <>

                    {innerKey != undefined &&
                    value != undefined &&
                    value != null &&
                    innerKey !== "user_id" ? (
                      <div
                        className="row RoleButton totalscore"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                          marginLeft: "20px",
                          
                        }}
                      >
                        <div
                          className="col-6 mt-3"
                          style={{ paddingLeft: "29px" }}
                        >
                          <h2 style={{ color: "#234492", width: "500px" }}>
                            Total Score 
                          </h2>
                        </div>
                        <div
                          className="col-6 mt-3"
                          style={{ paddingLeft: "59px" }}
                        >
                          <button
                            class="btn SaveBtn"
                            style={{ padding: "6px 5px" }}
                          >
                            {value}
                          </button>
                        </div>
                      </div>
                    ) : null}
                  </>
                )}
              </div>
            );
          })}

        <>
          {nextCall &&
            state.ManPowerActiveDataTabs.SetthefristNameofassessmentemp == ///the  names are equals ,,, then its have to display the total_points
              state.ManPowerActiveDataTabs.LastIDSPerformanceidss &&
            state.ManPowerActiveDataTabs.LastObjectWithName_total !=
              undefined &&
            Object.keys(
              state.ManPowerActiveDataTabs.LastObjectWithName_total
            ).map((item, index) => {
              console.log(item, "ite7hffm");
              const value =
                state.ManPowerActiveDataTabs.LastObjectWithName_total[item];
              console.log(typeof value === "object", "hnsa89jn");

              return (
                <>
                  {typeof value === "object" ? (
                    <>
                      {Object.entries(value).map(
                        ([subKey, subValue], index) => {
                          console.log(
                            subValue,
                            "subkeyvaluesadas",
                            index,
                            subValue + subValue
                          );
                          addedValue(subValue);
                          return (
                            <>
                              <div
                                div
                                className="row"
                                style={{
                                  marginRight: "0px",
                                  padding: "12px 40px",
                                }}
                              >
                                <div className="col-6">
                                  <h5
                                    style={{
                                      fontSize: "20px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {formatKey(subKey)}
                                  </h5>
                                </div>
                                <div className="col-6">
                                  <p
                                    style={{
                                      color: "#234492",
                                      fontWeight: "600",
                                      fontSize: "20px",
                                    }}
                                  >
                                    {subValue}
                                  </p>
                                </div>
                              </div>
                            </>
                          );
                        }
                      )}
                    </>
                  ) : null}
                </>
              );
            })}

          {nextCall &&
          state.ManPowerActiveDataTabs.SetthefristNameofassessmentemp == ///the  names are equals ,,, then its have to display the total_points
            state.ManPowerActiveDataTabs.LastIDSPerformanceidss ? (
            <>
              <div
                className="row RoleButton"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  padding: "12px 40px",
                  marginBottom: "30px",
                  bordeR: "4px solid red",
                
                }}
              >
                <div className="col-6 mt-3" style={{ paddingLeft: "29px" }}>
                  <h2 style={{ color: "#234492", width: "500px" }}>
                    Total Score
                  </h2>
                </div>
                <div className="col-6 mt-3" style={{ paddingLeft: "5px" }}>
                  <button class="ButtonCSS SaveBtn" style={{ textAlign: "center" }}>
                    {total_scorestta.total_score}
                  </button>
                </div>

                <div
                  className="button1"
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "flex-start",
                    marginLeft: "34px",
                    marginTop: "50px",
                  }}
                >
                  {/* {state.skillassessmentretieveempdatas.skillassessmentsempDatas !=
                    undefined &&
                  state.skillassessmentretieveempdatas.skillassessmentsempDatas !=
                    null &&
                  state.skillassessmentretieveempdatas.skillassessmentsempDatas
                    .user_id != undefined &&
                  state.skillassessmentretieveempdatas.skillassessmentsempDatas
                    .user_id != null &&
                  state.skillassessmentretieveempdatas.skillassessmentsempDatas.user_id.first_name.toUpperCase() ? (
                    <p
                      style={{
                        fontWeight: "700",
                        fontSize: "18px",
                        width: "100%",
                      }}
                    >
                      {state.skillassessmentretieveempdatas.skillassessmentsempDatas.user_id.first_name.toUpperCase()}
                      _is Scoring and
                      <span
                        style={{
                          color: "#F37338",
                          fontWeight: "900",
                        }}
                      >
                        {" "}
                        "A"
                      </span>
                      Grade
                    </p>
                  ) : (
                    <p>{"---"}</p>
                  )} */}
                  <p style={{width:"48%"}}></p>
                  <button
                    class=" SaveBtn ButtonCSS"
                    style={{
                      fontWeight: "600",
                      // width: "50%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                    }}
                    // total_score
                    onClick={(e) => {
                      const payload = {
                        innerdata: {
                          total_score:total_scorestta.total_score,
                          user_id:state.ManPowerActiveDataTabs.Employeeskillassessmentids,
                          is_completed:true

                        },
                        EditId: state.ManPowerActiveDataTabs.putIDS,
                        count: 2,
                      };
                      dispatch(gettheSkillassessmentputtmethodEmpactions(payload));
                    }}
                  >
                    {"update"}
                  </button>
                </div>
              </div>
            </>
          ) : null}
        </>
        {!nextCall ? (
          <div
            className=" col-9 RoleButton"
            style={{
              display: "flex",
              gap: "15px",
              justifyContent: "flex-end",
              alignItems: "center",
              padding: "40px",
              // width: "90%",
              marginTop: "30px",
            }}
          >
            {previousecount ? (
              <button
                class="btn CancelBtn"
                onClick={(e) => {
                  handelPrevious();
                }}
              >
                Previous
              </button>
            ) : null}
            <button
              class="btn CancelBtn"
              onClick={(e) => {
                HandleNext();
              }}
            >
              Next
            </button>
          </div>
        ) : null}
        </div>
      </div>
    </>
  );
};

export default EmpSkillassessmenforms;

